import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'

export const roles = createQueryKeys('roles', {
  all: null,
})

export type CountryKeys = inferQueryKeys<typeof roles>
